(() => {
  class AteaseBestsellersTrack extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.viewport = this.querySelector('[data-atease-track-viewport]');
      this.prev = this.querySelector('[data-atease-track-previous]');
      this.next = this.querySelector('[data-atease-track-next]');
      this.status = this.querySelector('[data-atease-track-status]');
      if (!this.viewport || !this.prev || !this.next || !this.status) return;
      this.items = [...this.viewport.children];
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.viewport.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.viewport);
      this.update();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
    }

    index() {
      return this.items.reduce((best, item, index) =>
        Math.abs(item.offsetLeft - this.viewport.scrollLeft) <
        Math.abs(this.items[best].offsetLeft - this.viewport.scrollLeft) ? index : best, 0);
    }

    move(direction) {
      const item = this.items[this.index() + direction];
      if (!item) return;
      this.viewport.scrollTo({
        left: Math.min(item.offsetLeft, this.viewport.scrollWidth - this.viewport.clientWidth),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }

    update() {
      const left = this.viewport.scrollLeft;
      const right = left + this.viewport.clientWidth;
      this.prev.disabled = left <= 1;
      this.next.disabled = right >= this.viewport.scrollWidth - 1;
      const complete = this.items.map((item, index) => ({ item, index })).filter(({ item }) =>
        item.offsetLeft >= left - 1 && item.offsetLeft + item.offsetWidth <= right + 1);
      const first = complete[0]?.index ?? this.index();
      const last = complete.at(-1)?.index ?? first;
      const range = first === last ? `${first + 1}` : `${first + 1}–${last + 1}`;
      this.status.textContent = this.items.length ? `${range} / ${this.items.length}` : '0 / 0';
    }
  }

  if (!customElements.get('atease-bestsellers-track')) {
    customElements.define('atease-bestsellers-track', AteaseBestsellersTrack);
  }
})();
